import styled from 'styled-components';
import {
  CardMedia,
  Typography,
  MenuItem,
  ListItemIcon,
} from '@material-ui/core';

export const Title = styled(Typography)`
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const CardImage = styled(CardMedia)`
  background-size: 'contain';
  width: 300px;
  height: 40px;
  filter: drop-shadow(1px 2px 2px black);
`;

export const Spacer = styled.span`
  flex: 1;
`;

export const MenuStyledItem = styled(MenuItem)`
  &&& {
    color: rgba(0, 0, 0, 0.54);
  }
`;

export const ListStyledItemIcon = styled(ListItemIcon)`
  &&& {
    min-width: 40px;
  }
`;
